// src/components/ui/TextField.tsx
import React from 'react';
import { TextField as MUITextField, TextFieldProps } from '@mui/material';

const TextField: React.FC<TextFieldProps> = (props) => {
  return <MUITextField fullWidth margin="normal" {...props} />;
};

export default TextField;
